export enum FeatureTemplateStatus {
  Active = "Active",
  Archived = "Archived",
}
